export class UrlProvider {
    static get root() {
        if (window.location.origin === "http://127.0.0.1:8080" || window.location.origin === "https://localhost:7948") { 
            return "https://localhost:7948";
        } else 
            return `https://r2.eurowheels.dk/fleet`;
    }
}